var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline"},[_c('p',{staticClass:"timeline__heading"},[_vm._v(" "+_vm._s(_vm.$t('heading'))+" ")]),_c('TagsSlider'),_c('p',{staticClass:"timeline__text",domProps:{"innerHTML":_vm._s(_vm.$t('text'))}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }